document.addEventListener('DOMContentLoaded', function() {
  // Detect if the device is iOS (exclude macOS)
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent) && !/Macintosh/i.test(navigator.userAgent);
  // Detect mobile devices (including iOS and Android, based on screen width and touch)
  const isMobile = window.matchMedia('(max-width: 768px)').matches || 'ontouchstart' in window;
  console.log('Device detection:', isIOS ? 'iOS detected' : 'Non-iOS device detected', isMobile ? 'Mobile detected' : 'Non-mobile detected');

  // Add classes to the body to indicate device type for CSS targeting
  document.body.classList.add(isIOS ? 'is-ios' : 'is-non-ios');
  document.body.classList.add(isMobile ? 'is-mobile' : 'is-non-mobile');

  // Initialize Flickity
  const carousel = document.querySelector('.flickity-carousel');
  if (!carousel) {
    console.error('Flickity carousel not found in the DOM');
    return;
  }

  // Define Flickity options
  const flickityOptions = {
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    autoPlay: 5000, // 5 seconds for slide-to-slide transition
    pauseAutoPlayOnHover: true,
    prevNextButtons: true,
    pageDots: true,
    freeScroll: false,
    friction: 0.28,
    selectedAttraction: 0.025
  };

  console.log('Flickity options:', flickityOptions);
  console.log('Autoplay speed set to:', flickityOptions.autoPlay, 'ms');

  // Initialize Flickity
  const flkty = new Flickity(carousel, flickityOptions);
  console.log('Flickity initialized successfully');

  // Log auto-play status
  flkty.on('play', function() {
    console.log('Flickity auto-play started');
  });
  flkty.on('pause', function() {
    console.log('Flickity auto-play paused');
  });

  // Variable to track if carousel is in view
  let isCarouselInView = false;

  // Use Intersection Observer to detect when carousel is in view
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      isCarouselInView = entry.isIntersecting;
      if (isMobile) {
        console.log('Mobile device: Ensuring poster images are displayed');
        restorePosters();
      } else if (isCarouselInView && !isIOS) {
        console.log('Carousel in view, triggering video playback (non-iOS, non-mobile)');
        playCurrentVideo();
      } else {
        console.log('Carousel out of view or on iOS, pausing videos');
        pauseAllVideos();
      }
    });
  }, {
    threshold: 0.5 // Trigger when 50% of the carousel is visible
  });

  observer.observe(carousel);

  // Attach event listeners after initialization
  flkty.on('ready', function() {
    console.log('Flickity ready event triggered');
    if (isMobile) {
      console.log('Mobile device: Ensuring poster images on ready');
      restorePosters();
    } else if (!isIOS && isCarouselInView) {
      playCurrentVideo();
    } else {
      console.log('Auto-play disabled on iOS or carousel not in view');
    }
  });

  flkty.on('change', function(index) {
    console.log('Flickity slide changed, selected index:', index);
    if (isMobile) {
      console.log('Mobile device: Ensuring poster images on slide change');
      restorePosters();
    } else if (!isIOS && isCarouselInView) {
      setTimeout(() => {
        playCurrentVideo();
      }, 500);
    } else {
      console.log('Auto-play disabled on iOS or carousel not in view during slide change');
    }
  });

  // Remove poster attributes on non-iOS, non-mobile devices and add a class to confirm
  if (!isIOS && !isMobile) {
    const videos = document.querySelectorAll('.carousel-video');
    videos.forEach(video => {
      const posterUrl = video.getAttribute('poster');
      if (posterUrl) {
        video.setAttribute('data-poster', posterUrl);
        video.removeAttribute('poster');
        video.classList.add('poster-removed');
        console.log('Poster attribute removed for video:', video.querySelector('source').src);
      }
    });
  }

  // Pause all videos and restore poster on mobile
  function pauseAllVideos() {
    const videos = document.querySelectorAll('.carousel-video');
    videos.forEach(video => {
      video.pause();
      video.currentTime = 0;
      if (isMobile) {
        const posterUrl = video.getAttribute('data-poster') || video.getAttribute('poster');
        if (posterUrl && !video.getAttribute('poster')) {
          video.setAttribute('poster', posterUrl);
          video.classList.remove('poster-removed');
          video.load(); // Reload to ensure poster displays
          console.log('Poster attribute restored and video reloaded for:', video.querySelector('source').src);
        }
      }
    });
  }

  // Restore posters on mobile devices
  function restorePosters() {
    const videos = document.querySelectorAll('.carousel-video');
    videos.forEach(video => {
      const posterUrl = video.getAttribute('data-poster') || video.getAttribute('poster');
      if (posterUrl && !video.getAttribute('poster')) {
        video.setAttribute('poster', posterUrl);
        video.classList.remove('poster-removed');
        video.load(); // Reload to force poster display
        console.log('Poster restored and video reloaded for:', video.querySelector('source').src);
      } else if (posterUrl) {
        video.load(); // Reload to ensure poster is rendered
        console.log('Poster already present, reloading video for:', video.querySelector('source').src);
      }
    });
  }

  // Play video in the current cell for 5 seconds (non-iOS, non-mobile only)
  function playCurrentVideo() {
    if (isIOS || isMobile) {
      console.log('Auto-play disabled on iOS or mobile');
      return;
    }
    if (!isCarouselInView) {
      console.log('Carousel not in view, skipping video play');
      return;
    }
    console.log('playCurrentVideo function called');
    const videos = document.querySelectorAll('.carousel-video');
    if (!videos.length) {
      console.error('No carousel videos found in the DOM');
      return;
    }

    videos.forEach(video => {
      video.loop = false;
      video.pause();
      video.currentTime = 0;
      video.style.display = 'block';
    });

    const currentCell = flkty.selectedElement;
    if (!currentCell) {
      console.error('No selected cell found in Flickity');
      return;
    }

    const video = currentCell.querySelector('.carousel-video');
    if (!video) {
      console.error('No video found in the selected cell');
      return;
    }

    // Ensure the video is ready to play
    const playVideo = () => {
      console.log('Attempting to play video:', video.querySelector('source').src);
      video.play()
        .then(() => {
          console.log('Video playback started successfully');
          setTimeout(() => {
            video.pause();
            console.log('Video paused after 5 seconds');
          }, 5000); // Match slide duration
        })
        .catch(error => {
          console.error('Video playback failed:', error.message);
        });
    };

    // Attempt to load the video
    video.load();
    if (video.readyState >= 2) {
      console.log('Video is ready to play (readyState:', video.readyState, ')');
      playVideo();
    } else {
      console.log('Video not ready (readyState:', video.readyState, '), waiting for canplay event');
      video.addEventListener('canplay', playVideo, { once: true });
      video.addEventListener('error', () => {
        console.error('Video loading failed:', video.querySelector('source').src);
      }, { once: true });
      setTimeout(() => {
        if (video.readyState < 2) {
          console.error('Video failed to become ready for playback (readyState:', video.readyState, ')');
        }
      }, 5000);
    }
  }

  // Lightbox functionality
  const lightbox = document.getElementById('video-lightbox');
  if (!lightbox) {
    console.error('Video lightbox not found in the DOM');
    return;
  }

  const lightboxVideo = lightbox.querySelector('.lightbox-video');
  const lightboxSource = lightboxVideo.querySelector('source');
  const closeButton = lightbox.querySelector('.lightbox-close');

  // Function to open lightbox
  function openLightbox(videoUrl) {
    lightboxSource.setAttribute('src', videoUrl);
    lightboxVideo.load();
    lightbox.style.display = 'flex';
    lightboxVideo.play().catch(error => console.error('Lightbox video play failed:', error));
    flkty.pausePlayer();
  }

  // Add click event to videos
  document.querySelectorAll('.carousel-video').forEach(video => {
    video.addEventListener('click', function() {
      const videoWrapper = this.closest('.video-wrapper');
      const videoUrl = videoWrapper.getAttribute('data-video-url');
      if (videoUrl) {
        openLightbox(videoUrl);
      } else {
        console.error('No data-video-url found on .video-wrapper');
      }
    });
  });

  // Add click event to play icons
  document.querySelectorAll('.play-icon').forEach(icon => {
    icon.addEventListener('click', function() {
      const videoWrapper = this.closest('.video-wrapper');
      const videoUrl = videoWrapper.getAttribute('data-video-url');
      if (videoUrl) {
        openLightbox(videoUrl);
      } else {
        console.error('No data-video-url found on .video-wrapper');
      }
    });
  });

  // Close lightbox
  closeButton.addEventListener('click', function() {
    lightbox.style.display = 'none';
    lightboxVideo.pause();
    flkty.playPlayer();
  });

  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) {
      lightbox.style.display = 'none';
      lightboxVideo.pause();
      flkty.playPlayer();
    }
  });
});